module.exports = __webpack_public_path__ + "static/media/odds.ad98aca7.svg";